import { EntityIdBase } from './EntityIdBase';

export class Usuario extends EntityIdBase{
    Login: string = "";
    Password: string = "";
    Nombre: string = "";
    Activo: boolean = true;
    Intentos: number = 0;
    Rol: number = 0;
}